import { useQuery } from '@tanstack/react-query';

// Hook pour les données statiques (pays, villes, etc.)
export const useAppData = () => {
  return useQuery({
    queryKey: ['appData'],
    queryFn: async () => {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/datas/fr`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Erreur lors du chargement des données');
      }
      
      return data;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes (données statiques)
    refetchOnWindowFocus: false,
    retry: 2,
  });
};